/* globals Store */
import axios from 'axios'
import qs from 'qs'
import cfg from '@/vue-caas/config/config.js'
import {
  handleResponseError,
  alertSuccess,
  closeAlert,
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

const BASE_URL = `${cfg.dlbApiUrl}/`;    // http://172.20.130.197:8181/
//const BASE_URL = 'http://localhost:8181/'


const ajax = axios.create({
  baseURL: BASE_URL,
  // timeout: 30000
  timeout: false
  // params: {} // do not remove this, its added to add params later in the config
})

// Add a request interceptor
ajax.interceptors.request.use(function (config) {
  // http 헤더에 추가해야 할 것이 있으면 여기서 하기.
  // 아래는 Caas와 합치면서 없앰.
  //const {token} = Store.state.user;
  //console.log("token - ", token)
  //if (token) {
    //config.headers.common['Authorization'] = 'Bearer ' + token
    //config.headers.common['Access-Control-Allow-Origin'] = '*'
  //} else {
    // Use application/x-www-form-urlencoded for login
    //config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
  //}
  showProgress("Please stand by");
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

ajax.interceptors.response.use(
  function (response) {
    hideProgress();
    closeAlert(1000);
    console.log('--------- RESPONSE -------------');
    // console.log(response.data);
    return response;
  },
  function (error) {
    console.log('-------- RESPONSE ERROR --------');
    console.log(error);
    hideProgress();
    handleResponseError(error);
    return Promise.reject(error);
  }
)

export default {
  putData (action, data) {
    console.log('------ REQUEST (putData) -------');
    // console.log(data)
    let url = `${BASE_URL}`
    url += action
    return ajax({
      method: 'put',
      url: url,
      data: qs.stringify(data),
      //timeout: 30000,
      timeout: false,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    })
  },
  readFile (action, data) {
    let url = `${BASE_URL}`
    url += action
    return ajax({
      method: 'put',
      url: url,
      data: qs.stringify(data),
      //timeout: 30000,
      timeout: false,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    })
  },
  trFileSend (action, formdata) {
    let url = `${BASE_URL}`
    url += action
    return ajax({
      method: 'put',
      url: url,
      data: formdata,
      processData: false,
      contentType: false,
      cache: false,
      //timeout: 60000,
      timeout: false,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  downloadFile (action, data) {
    let url = `${BASE_URL}`
    url += action
    return ajax({
      method: 'post',
      url: url,
      data: qs.stringify(data),
      responseType: 'blob',
      //timeout: 30000,
      timeout: false,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    })
  }

}
